import React from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

import './main_menu.scss'

export default ({ label, route, noChildren }) => {
  return (
    <div className="main-menu-container">
      <ul className="menu">
        <li>
          <Link to={route}>
            {label}
            {!noChildren && (
              <FontAwesomeIcon icon={faChevronDown} />
            )}
          </Link>
        </li>
      </ul>
    </div>
  )
}
